/* angular */
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

/* Solar */
import { ChipModule, SolValidatorModule, SolarFormModule, SolModalModule } from '@solar/components';
import { NgbModal, NgbDropdownModule, NgbDropdownConfig, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

/* Manage MFA Device */
import { ManageMFADeviceComponent } from './manage-mfa-device-component';
import { ActivateDeviceComponent } from './activate-device/activate-device.component';
import { DelinkDeviceComponent } from './delink-device/delink-device.component';
import { EditDeviceComponent } from './edit-device/edit-device.component';
import { MfaDeviceService } from './services/mfa-device.service';
import { SolarLunarModule } from '@solar/lunar';
import { SolarTooltipModule } from '@solar/tooltip';
import { FeatureFlagModule } from '../feature-flag/feature-flag.module';
import { DelinkDeviceV2Component } from './delink-device-v2/delink-device-v2.component';
import { ActivateDeviceV2Component } from '@threshold/components/manage-mfa-device/activate-device-v2/activate-device-v2.component';
import { NoDeviceYetComponent } from './no-device-yet/no-device-yet.component';

@NgModule({
    imports: [
        ChipModule,
        CommonModule,
        HttpClientModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        SolarFormModule,
        SolValidatorModule,
        SolModalModule,
        NgbDropdownModule,
        SolarLunarModule,
        FeatureFlagModule,
        NgbTooltipModule,
        SolarTooltipModule,
    ],
    exports: [ManageMFADeviceComponent, ActivateDeviceComponent, DelinkDeviceComponent, EditDeviceComponent, DelinkDeviceV2Component, ActivateDeviceV2Component, NoDeviceYetComponent], 
    providers: [NgbModal, MfaDeviceService, NgbDropdownConfig],
    declarations: [ManageMFADeviceComponent, ActivateDeviceComponent, DelinkDeviceComponent, EditDeviceComponent, DelinkDeviceV2Component, ActivateDeviceV2Component, NoDeviceYetComponent],
})
export class ManageMFADeviceModule {
    constructor() {}
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/manage-mfa-device/manage-mfa-device.module.ts